module.exports = __webpack_public_path__ + "img/DC-appointments-night.f9347f28.svg";